export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-support.38cf2891.svg","height":69,"width":70,"blurWidth":0,"blurHeight":0};